<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 class="title-default">Arquivo</h1>
        </div>
        <div class="col-sm-6">
            <a type="button" mat-button class="btn-primary btn-add-right" routerLink="/desenvolvedor/arquivo/cadastrar" *appTemPermissao="_PermissaoEnum.Desenvolvedor_Arquivo_Incluir">
                <mat-icon>add</mat-icon>
                Novo Arquivo
            </a>
        </div>
    </div> 
    <form class="form" [formGroup]="model"  (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Arquivo</mat-label>
                    <input matInput formControlName="arquivo" type="text">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Versão</mat-label>
                    <input matInput formControlName="versao" type="text">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Selecione uma categoria</mat-label> 
                    <mat-select formControlName="listaCategoriaArquivo" (selectionChange)="habilitaSelecaoCategoria()">
                        <mat-option [value]="null">Limpar seleção</mat-option>
                        @if(_categoriaLookupResponse){
                            @for (categoriaArquivo of _categoriaLookupResponse.listaCategoriaArquivo; track categoriaArquivo) {
                                <mat-option [value]="categoriaArquivo.idCategoriaArquivo">{{categoriaArquivo.nome}}</mat-option>
                            }
                        }
                    </mat-select>  
                    @if (model.get('listaCategoriaArquivo')?.invalid) {
                        <mat-error>Selecione uma categoria</mat-error>
                    }  
                </mat-form-field>
            </div>
            
            <div class="col-md-6">
                <button type="submit" mat-button class="btn-secundary" style="width: 140px;">
                    Pesquisar
                </button>
            </div> 
        </div>
    </form>

    @if(this._listaArquivoResponse && this._listaArquivoResponse?.listaArquivo){
        <table mat-table [dataSource]="_dataSource">
        
          <ng-container matColumnDef="nomeArquivo">
              <th mat-header-cell *matHeaderCellDef> Nome </th>
              <td mat-cell *matCellDef="let element"> {{element.nome}} </td>
            </ng-container>

             <ng-container matColumnDef="versaoArquivo">
                <th mat-header-cell *matHeaderCellDef> Versão </th>
                <td mat-cell *matCellDef="let element"> {{element.versao}} </td>
            </ng-container>

            <ng-container matColumnDef="categoriaArquivo">
                <th mat-header-cell *matHeaderCellDef> Categoria </th>
                <td mat-cell *matCellDef="let element"> {{element.categoriaArquivo.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="tagArquivo">
                <th mat-header-cell *matHeaderCellDef> Tag </th>
                <td mat-cell *matCellDef="let element"> {{element.tagArquivo.nome}} </td>
            </ng-container>

              <ng-container matColumnDef="dataAlteracao">
                <th mat-header-cell *matHeaderCellDef> Data upload </th>
                <td mat-cell *matCellDef="let element"> {{element.dataAlteracao | date: 'dd/MM/yyyy hh:mm:ss'}} </td>
            </ng-container>

             <ng-container matColumnDef="action-delete">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> 
                    <button type="button" mat-mini-fab aria-label="Excluir" class="fab-action default" (click)="abrirModalExcluir(element.idArquivo, element.nome)" *appTemPermissao="_PermissaoEnum.Desenvolvedor_Arquivo_Excluir">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>       

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(_isLoading === true){
        <table>
            @for (item of [1,2,3]; track item) {
                <tr>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                    </td>
                </tr>
            }
            
        </table>
    }
    @else if(this._listaArquivoResponse?.listaArquivo){
        <app-empty-list [title]="'Não foi encontrado nenhum arquivo com o filtro informado'"></app-empty-list>
    }
    
</div>
